<div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
    <mat-form-field *ngIf="showInput" appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
        <textarea
            #url
            [disabled]="disabled"
            matInput
            type="text"
            [formControl]="urlSource | cast"
            i18n-placeholder
            [placeholder]="placeholder"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="10"
        ></textarea>
        <button
            matTooltip="Open link in new tab"
            i18n-matTooltip
            type="button"
            *ngIf="!!urlSource.value && Utils.isUrl(urlSource.value)"
            class="open-link"
            mat-icon-button
            matSuffix
            (click)="goToLink(urlSource.value)"
        >
            <mat-icon>open_in_new</mat-icon>
        </button>
    </mat-form-field>
    <div *ngIf="!!urlSource.value && Utils.isUrl(urlSource.value)" fxLayoutAlign="start start" fxLayout="column">
        <app-media-view
            fxLayoutAlign="center center"
            *ngIf="mediaKey as mediaId"
            fxFlex="0 0 100%"
            [media_id]="mediaId"
        >
        </app-media-view>
        <ng-container *ngIf="showYoutubeMetadata">
            <ng-container *ngIf="!!urlSource.value && Utils.isYoutubeURL(urlSource.value)">
                <ng-container *ngIf="youTubeVideoInfo$ | async; let videoData; else: youTubeNoInfo">
                    <div class="info-wrapper" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Video title: </span>
                            <span class="info">{{ videoData.title }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Duration: </span>
                            <span class="info">{{ videoData.duration | formatIsoDuration }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Source: </span>
                            <span class="info">Youtube</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>
<ng-template #youTubeNoInfo
    ><ng-container *ngIf="isLoadingVideoInfo" [ngTemplateOutlet]="smallLoading"></ng-container>
</ng-template>

<ng-template #smallLoading>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
